import Vue from 'vue'
import VueI18n from '@klook/vue-i18n'
Vue.use(VueI18n)
// import { admin_language_codes, layout_options } from '../../admin-cli.config.js'
// import { layout_options } from '../../admin-cli.config.js'
import { createRouter as registerRouter } from '../router'

// async function registerElementUI(ctx) {
//   const { i18n } = ctx
//   const ElementUI = await import('element-ui')
//   await import('element-ui/lib/theme-chalk/index.css')
//   Vue.use(ElementUI.default || ElementUI, {
//     i18n: (key, value) => i18n.t(key, value)
//   })
// }

// async function registerAntdUI() {
//   const Antd = await import('ant-design-vue')
//   await import('ant-design-vue/dist/antd.less')
//   Vue.use(Antd.default || Antd)
//   return Promise.resolve()
// }

// function registerAdminI18n(ctx) {
//   // i18n
//   function getLanguage() {
//     const chooseLanguage = window.localStorage.getItem('language')
//     if (chooseLanguage) return chooseLanguage
//     // if has not choose language
//     const language = (
//       navigator.language || navigator.browserLanguage
//     ).toLowerCase()
//     return language || 'en'
//   }

//   // default admin UI languages, modify as needed
//   const module_locales = require.context(
//     '../modules',
//     true,
//     /\/locales\/admin\/[a-zA-Z0-9-_,\s]+\.js$/i
//   )
//   console.log('module locale', { ...module_locales.keys() })

//   const locale = getLanguage()

//   function loadlocalemessages() {
//     let messages = {}
//     admin_language_codes.forEach(({ F_LANG: lang }) => {
//       messages[lang] = {
//         ...module_locales
//           .keys()
//           .filter((v) => v.match(lang))
//           .reduce(
//             (acc, cur) => ({
//               ...acc,
//               ...module_locales(cur).default
//             }),
//             {}
//           )
//       }
//     })

//     console.log('messages==>', messages)

//     return messages
//   }

//   const messages = loadlocalemessages()

//   window.__ = function(key) {
//     return _.get(messages[locale], key, key)
//   }

//   // Create VueI18n instance with options
//   const i18n = new VueI18n({
//     locale, // set locale
//     messages // set locale messages
//   })

//   i18n.admin_language_codes = admin_language_codes
//   ctx.i18n = i18n
// }

// async function registerLayout(ctx) {
//   const KlkLayout = await import('@klook/admin-layout')
//   Vue.use(KlkLayout.default || KlkLayout, { options: layout_options })
// }

async function registerLogin(ctx) {
  const { router } = ctx
  let _admin_login = await import('@klook/admin-login')
  const { useLogin } = _admin_login
  useLogin(router)
}

async function registerPermission(ctx) {
  const { router } = ctx
  let { usePermission } = await import('@klook/admin-permission')
  usePermission(router, {
    noPermissionPath: '/404'
  })
}

export async function registerAdmin(ctx) {
  // await registerAdminI18n(ctx)
  // await registerLayout(ctx)
  await registerRouter(ctx)
  await registerLogin(ctx)
  await registerPermission(ctx)
  // await registerAntdUI(ctx)

  return ctx
}
